import gql from 'graphql-tag';

export default gql`
  mutation paymentOrderDelete($_id: ID!) {
    paymentOrderDelete(_id: $_id) {
      succeed
    }
  }
`;
